import React, { useState, SyntheticEvent } from 'react';
import styles from './sharing.module.scss';
import { OrderManagementRequest } from 'core/entities';
import { RecordType } from '../requests-table/requests-table';
import { ShareButton } from './components/share-button/share-button';
import { HeaderTextProps } from 'ui-components/share-report-modal/share-report-modal';
import { ShareReportModal } from './components/share-report-modal/share-report-modal';
import { useSegmentCallback } from 'hooks/use-segment-callback/use-segment-callback';

export type SharingComponentProps = {
    record: RecordType | OrderManagementRequest;
    hoveringRecordId?: number;
};

export const SharingComponent = ({ record, hoveringRecordId }: SharingComponentProps) => {
    const { zipFile, mapsLink, tablouLink } = record;

    const { reportName, reportDates, entities } = record;
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { track } = useSegmentCallback();
    const headerTextProps: HeaderTextProps = {
        primaryText: `Share ${reportName}`,
        secondaryText: `${entities[0].name}`,
        tertiaryText: `${reportDates}`,
    };

    const onShareButtonClick = (e: SyntheticEvent<EventTarget>) => {
        e.stopPropagation();
        setModalVisible(true);
        track({
            category: 'Marketplace',
            action: 'XTRA Share',
            label: reportName,
        });
    };

    return (
        <div className={styles.sharingButtonsWrapper}>
            {(zipFile || mapsLink || tablouLink) && (
                <div className={styles.shareButtonWrapper}>
                    <ShareButton
                        onClick={onShareButtonClick}
                        record={record}
                        hoveringRecordId={hoveringRecordId}
                    />
                    <div onClick={(e) => e.stopPropagation()}>
                        {modalVisible && (
                            <ShareReportModal
                                visible={modalVisible}
                                headerContent={headerTextProps}
                                onCloseModal={() => setModalVisible(false)}
                                record={record}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
